export const gettingAdmins = (state: any) => state.gettingAdmins;
export const fetchAdmins = (state: any) => state.admins;
export const getAdminsError = (state: any) => state.getAdminsError;
